import * as React from 'react';
var getRefElement = function (element) {
    if (element && 'current' in element) {
        return element.current;
    }
    return element;
};
var useEventListener = function (_a) {
    var type = _a.type, listener = _a.listener, _b = _a.element, element = _b === void 0 ? window : _b, options = _a.options;
    var savedListener = React.useRef();
    React.useEffect(function () {
        savedListener.current = listener;
    }, [listener]);
    var handleEventListener = React.useCallback(function (event) {
        var _a;
        (_a = savedListener.current) === null || _a === void 0 ? void 0 : _a.call(savedListener, event);
    }, []);
    React.useEffect(function () {
        var target = getRefElement(element);
        target === null || target === void 0 ? void 0 : target.addEventListener(type, handleEventListener, options);
        return function () {
            target === null || target === void 0 ? void 0 : target.removeEventListener(type, handleEventListener);
        };
    }, [type, element, options, handleEventListener]);
};
export default useEventListener;
//# sourceMappingURL=useEventListener.js.map